import React from 'react';

const LeftPane = () => {
    return (
        <div className='mt-3'>
            <h1>Trevor Vandergrift</h1>
            <h2>IT Professional</h2>
            <hr />
            <p>I’ve spent years supporting systems and solving problems — now I’m focused on building web experiences. I bring technical expertise, a service mindset, and a drive to make things better!</p>
        </div>

    )
}

export default LeftPane;